import { http } from "Utils/http";
import { httpDownload } from "Utils/httpDownload";
import { STATUSES } from "Utils/constants";

// get topic list for the chatbot
const getTopics = async () => {

  let status = STATUSES.SUCCESS;
  let body = {}

  const url = "/api/chatbot/getTopics";
  const res = await http.post(url, body, {})
    .then((res) => {
      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

// get answer from the chatbot
const query = async (request) => {

  let status = STATUSES.SUCCESS;
  // Ex. for the request body
  // {
  //   "message": "what is implementation guide",
  //   "topic": -1,
  //   "sessionId": "3cfac7d7-c65b-4aa7-a3f1-d0e68795dd99",
  //   "resetMemory": false
  // }

  // let body = {
  //   "message": "what is implementation guide",
  //   "topic": -1,
  //   "sessionId": "3cfac7d7-c65b-4aa7-a3f1-d0e68795dd99",
  //   "resetMemory": false
  // }

  const url = "/api/chatbot/query";
  const res = await http.post(url, request, {})
    .then((res) => {
      console.log("query()", res);
      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
}

// download the document by the groupId
const getDocumentDownload = async (groupId) => {

  var url = '/api/dlms/downloadDocument';

  return httpDownload.post(url, { "groupId": groupId }, {
    responseType: 'blob',
    headers: {
      "Authorization": "Bearer "
    }
  });
}

// save chat feedback
const saveChatFeedback = async (body) => {

  let status = STATUSES.SUCCESS;

  // Ex. body
  // {
  //   chatId: Ex. 20,
  //   isHelpful: Ex. 0=No, 1=Yes,
  //   reasonIds: [] List
  // }

  //let body = {}

  const url = "/api/chatbot/feedback";
  const res = await http.post(url, body, {})
    .then((res) => {
      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

// get topic list for the chatbot
const getChatIssueReasons = async () => {

  let status = STATUSES.SUCCESS;
  let body = {}

  const url = "/api/chatbot/getReasons";
  const res = await http.post(url, body, {})
    .then((res) => {
      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

// chatbot health check
const chatbotHealthCheck = async () => {

  let status = STATUSES.SUCCESS;
  let body = {}

  const url = "/api/chatbot/healthCheck";
  const res = await http.post(url, body, {})
    .then((res) => {
      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

export { getTopics, query, getDocumentDownload, saveChatFeedback, getChatIssueReasons, chatbotHealthCheck };